import { FC } from 'react';
import { Skeleton } from '@chakra-ui/react';
export const CbTagBoxSkeleton: FC = () => {
  return <Skeleton alignItems="center" paddingX="8px" paddingY="2px" borderWidth="1px" borderRadius="8px" width={20} minHeight={6} marginRight={2} marginBottom={2} data-sentry-element="Skeleton" data-sentry-component="CbTagBoxSkeleton" data-sentry-source-file="CbTagBoxSkeleton.tsx" />;
};